import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServicoDataService {
  httpClient = inject(HttpClient);
  buscarCep(cep: string) {
    const url = `https://viacep.com.br/ws/${cep}/json`;
    return lastValueFrom(this.httpClient.get(url));
  }

  async buscarPaisPorIp(): Promise<string | null> {
    try {
      const resposta = await fetch('https://get.geojs.io/v1/ip/country.json');
      if (!resposta.ok) {
        return null;
      }
      const data = (await resposta.json()) as { country?: string };
      const codigo = (data.country ?? '').trim().toUpperCase();
      return /^[A-Z]{2}$/.test(codigo) ? codigo : null;
    } catch {
      return null;
    }
  }
}
